import { gql, useQuery } from '@apollo/client';
import { useDispatch, useSelector } from 'react-redux';
import React from 'react';

import { RootState } from '../../../../reducers';
import { Service, ServiceInput } from '../../../../types/__codegen__/ahm-api/graphql';
import BuildYourCoverActions, { BuildYourCoverProductType } from '../../../../actions/build-your-cover';
import client from '../../../../graphql/client';
import LoadingSpinner from '../../../../components/loading-spinner';
import selectBuildYourCover from '../../../../selectors/select-build-your-cover';
import selectCustomer from '../../../../selectors/select-customer';
import ServiceSelection from '../components/service-selection';

const GET_SERVICES = gql`
  query GetServices($input: ServiceInput) {
    getServices(input: $input) {
      description
      name
      serviceId
    }
  }
`;
const headings = {
  extras: {
    subtitle: 'See our commonly chosen inclusions below or view the whole list.',
    title: 'Extras',
  },
  hospital: {
    subtitle: 'See our commonly chosen inclusions below or view the whole list.',
    title: 'Hospital',
  },
};

const ServiceSelectionWithDataLoader = ({ productType }: { productType: BuildYourCoverProductType }) => {
  const dispatch = useDispatch();
  const selectedServicesFromState = useSelector(
    (state: RootState) => selectBuildYourCover(state)?.selectedServices?.[productType],
  );

  const dob = useSelector(selectCustomer)?.members[0]?.dob;
  const setSelectedServices = (selectedServices: Service['serviceId'][]) => {
    BuildYourCoverActions.setSelectedServices(productType, selectedServices)(dispatch);
  };

  const { data, loading } = useQuery(GET_SERVICES, {
    client,
    variables: { input: { dob, productType } as ServiceInput },
  });

  if (loading) {
    return <LoadingSpinner />;
  }

  if (!data) {
    throw new Error('No data returned from GetServices query');
  }

  return (
    <ServiceSelection
      {...headings[productType]}
      selectedServices={selectedServicesFromState}
      serviceList={data.getServices}
      setSelectedServices={setSelectedServices}
    />
  );
};

export default ServiceSelectionWithDataLoader;
